"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuggestionResult = exports.Suggestion = exports.AutoSuggestionApi = void 0;
var tslib_1 = require("tslib");
var app_1 = require("app");
var json2typescript_1 = require("json2typescript");
var UtilService_1 = require("../../UtilService");
var Search_utils_1 = require("../Search.utils");
var AutoSuggestionApi = /** @class */ (function (_super) {
    tslib_1.__extends(AutoSuggestionApi, _super);
    function AutoSuggestionApi(config) {
        var _this = _super.call(this, config) || this;
        _this.buildAutoSuggestionUrl = function (endPoint, params) {
            return "".concat(endPoint, "?").concat(_this.buildAutoSuggestionQuery(params));
        };
        _this.mapSuggestionToSearchOption = function (data) { return ({
            query: data.term,
            term: data.highlightedTerm ? data.highlightedTerm : data.term,
        }); };
        return _this;
    }
    AutoSuggestionApi.prototype.getData = function (params) {
        var _this = this;
        if (!this.config.autoSuggestionEnabled) {
            return Promise.reject('Auto suggestions is disabled. BadRequest occured');
        }
        return _super.prototype.getData.call(this, params).then(function (data) {
            var jsonConvert = new json2typescript_1.JsonConvert();
            var suggestionResult = jsonConvert.deserialize(data, SuggestionResult);
            return _this.convertApiResultToUI(suggestionResult);
        });
    };
    AutoSuggestionApi.prototype.buildAutoSuggestionQuery = function (params) {
        var builder = new Search_utils_1.SearchParamsBuilder();
        //add additonal symbols "" to avoidd 500 error
        var valueConverterForQuery = function (value) { return "\"".concat(value, "\""); };
        builder.Append('q', params.query, valueConverterForQuery);
        builder.Append('lang', this.config.lang);
        builder.Append('country', this.config.country);
        return builder.toString();
    };
    AutoSuggestionApi.prototype.callApi = function (url, params) {
        var urlWithParams = this.buildAutoSuggestionUrl(url, params);
        return _super.prototype.callApi.call(this, urlWithParams, {});
    };
    AutoSuggestionApi.prototype.convertApiResultToUI = function (data) {
        var result = {};
        var maxResultsCount = this.config.maxResultsCount;
        if (data && data.suggestions) {
            result.autosuggestions = data.suggestions
                .slice(0, maxResultsCount)
                .map(this.mapSuggestionToSearchOption);
        }
        return result;
    };
    // Extended from BaseApi
    AutoSuggestionApi.prototype.createHeaders = function () {
        return {
            requestId: UtilService_1.UtilService.newUUID(),
        };
    };
    return AutoSuggestionApi;
}(app_1.BaseApi));
exports.AutoSuggestionApi = AutoSuggestionApi;
/* tslint:disable */
var Suggestion = /** @class */ (function () {
    function Suggestion() {
        this.term = undefined;
        this.highlightedTerm = undefined;
    }
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('term', String),
        tslib_1.__metadata("design:type", String)
    ], Suggestion.prototype, "term", void 0);
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('highlightedTerm', String, true),
        tslib_1.__metadata("design:type", String)
    ], Suggestion.prototype, "highlightedTerm", void 0);
    Suggestion = tslib_1.__decorate([
        (0, json2typescript_1.JsonObject)('Suggestion')
    ], Suggestion);
    return Suggestion;
}());
exports.Suggestion = Suggestion;
var SuggestionResult = /** @class */ (function () {
    function SuggestionResult() {
        this.suggestions = undefined;
    }
    tslib_1.__decorate([
        (0, json2typescript_1.JsonProperty)('suggestions', [Suggestion]),
        tslib_1.__metadata("design:type", Array)
    ], SuggestionResult.prototype, "suggestions", void 0);
    SuggestionResult = tslib_1.__decorate([
        (0, json2typescript_1.JsonObject)('SuggestionResult')
    ], SuggestionResult);
    return SuggestionResult;
}());
exports.SuggestionResult = SuggestionResult;
/* tslint:enable */
